import _ from 'lodash';
import { IFRAME_ID } from 'admin/components/pages/Story/CardEditor/Editor/EditorCanvas';

/**
 * @return {{contentDocument: *, contentWindow: *}|{}}
 */
export function getClientFrame() {
	if (typeof document === 'undefined') {
		console.error('document is undefined');
		return {};
	}
	const frame = document.getElementById(IFRAME_ID) as HTMLIFrameElement;

	return {
		contentDocument: _.get(frame, 'contentDocument'),
		contentWindow: _.get(frame, 'contentWindow'),
		frame,
	};
}

export function getClientFrameNode(id) {
	return getClientFrame().contentDocument.getElementById(id);
}

export function getClientFrameNodeStyles(id) {
	const frame = getClientFrame();
	const node = frame.contentDocument.getElementById(id);
	return node ? frame.contentWindow.getComputedStyle(node) : {};
}
